import React, { Component } from "react";
import { AuthLogin } from "../../services/auth-service";
import { app } from "../../index";
import { connect } from "react-redux";
import {
  Icon,
  Modal,
  Header,
  Input,
  Form,
  Button,
  Image,
  Message,
} from "semantic-ui-react";
import { queryserviceobject } from "../../services/crudservice";
class LoginModal extends Component {
  constructor() {
    super();
    this.state = {
      password: "",
      uname: "",
      message: "none",

    };
  }

  handlelogin() {
    const params = {
      username: this.state.uname,
      password: this.state.password,
      strategy: "local",
    };

    AuthLogin(params).then(user => console.log(user)).catch((err) => {
      console.log(err);
      if (
        err &&
        (err.message === "Invalid login" ||
          err.message === "Missing credentials")
      ) {
        this.setState({ message: "loginerror" });
      }
    });
  }
  getlogin(param, value) {
    console.log(param, value);
    return app
      .service("edfemployees")
      .find({
        query: {
          [param]: value,
        },
      })
      .then((response) => {
        console.log(response);
        if (response.data) {
          response = response.data;
        }
        if (response.length) {
          return response[0];
        }
      });
  }
  handlereset() {
    var loginparam;
    if (this.state.uname.indexOf("@") > -1) {
      loginparam = "workemail";
    } else {
      loginparam = "userid";
    }
    console.log(loginparam);
    this.getlogin(loginparam, this.state.uname).then((response) => {
      console.log(response);

      if (response && response.userid) {
        console.log("resetting " + response.userid);
        app
          .service("login")
          .patch(response.userid, {
            password: "edfinc",
            passwordreset: true,
          })
          .then((err) => {
            console.log(err);
            this.setState({ message: "passwordreset" });
          });
      } else {
        console.log("nope");
        this.setState({ message: "nounameerror" });
      }
    });
  }
  handlekeypress(e) {
    if (e.key === "Enter") {
      this.handlelogin();
    }
  }
  genmsg() {
    switch (this.state.message) {
      case "loginerror":
        return (
          <Message
            error
            header="Invalid Credentials"
            content="This username and password does not match our records."
          />
        );
        break;
      case "passwordreset":
        return (
          <Message
            info
            header="Password Reset"
            content="Your Password has been successfully reset."
          />
        );
        break;
      case "nounameerror":
        return (
          <Message
            error
            header="Unknown User"
            content="We do not recognize this userid or email address"
          />
        );

        break;
      default:
    }
  }
  render() {
    Object.getOwnPropertyNames(app).filter(function (property) {
      return typeof app[property] == 'function';
    }).map(fun => console.log('appfunction', fun));
    return (
      <div className="LoginModal">
        <Modal
          open={this.props.showModal}
          onClose={this.props.handleClose}
          closeOnEscape={false}
          closeOnRootNodeClick={false}
          size="small"
        >
          <Header as="h2">
            <Image
              src={require("./edf_logo.bmp")}
              size="small"
              id="loginheader"
            />
            Please Sign in to EDF
          </Header>
          <Modal.Content>
            <Form>
              <Form.Field>
                <label>Email or Employee Number</label>
                <Input
                  onChange={(e) => this.setState({ uname: e.target.value })}
                  labelPosition="right"
                  placeholder="email or employee number"
                />
              </Form.Field>

              <Form.Field>
                <label>Password</label>
                <input
                  placeholder="Password"
                  type="password"
                  onKeyPress={(e) => this.handlekeypress(e)}
                  onChange={(e) => this.setState({ password: e.target.value })}
                />
              </Form.Field>
            </Form>
            {this.genmsg()}
          </Modal.Content>
          <Modal.Actions>
            <Button
              color="green"
              type="submit"
              onClick={() => this.handlelogin()}
              inverted
            >
              <Icon name="checkmark" /> Signin
            </Button>
          </Modal.Actions>
        </Modal>
      </div>
    );
  }
}
function mapStateToProps(state) {
  return {
    showModal: state.modal === "login",
  };
}
export default connect(mapStateToProps)(LoginModal);



// WEBPACK FOOTER //
// ./src/components/shared-components/loginmodal.js